export default "__VITE_ASSET__D4oMsXU5__"